var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKaBehoerde(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#eff2fa;}.cls-3{fill:#577399;}.cls-4{fill:#a7bccf;}.cls-5{fill:#fff;}.cls-6{fill:#495867;}.cls-7{fill:#fe5f55;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Maske"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 160,
    height: 160,
    rx: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 77.83,
    y: 16.04,
    width: 4.77,
    height: 15.71
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 77.83,
    y: 51.91,
    width: 4.77,
    height: 15.11
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 58.75,
    y: 51.91,
    width: 4.77,
    height: 15.11
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 96.91,
    y: 51.91,
    width: 4.77,
    height: 15.11
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 87.37,
    y: 51.91,
    width: 4.77,
    height: 15.11
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 68.29,
    y: 51.91,
    width: 4.77,
    height: 15.11
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M151.77,90H8.66L34.89,66.13h90.64Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 22.97,
    y: 89.98,
    width: 116.88,
    height: 62.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 120.76,
    y: 99.53,
    width: 9.54,
    height: 9.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 113.61,
    y: 128.15,
    width: 9.54,
    height: 9.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 39.66,
    y: 128.15,
    width: 9.54,
    height: 9.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 32.51,
    y: 99.53,
    width: 9.54,
    height: 9.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 53.98,
    y: 99.53,
    width: 9.54,
    height: 9.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 99.3,
    y: 99.53,
    width: 9.54,
    height: 9.54
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M80.21,78.06,54,90h52.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M99.3,152V135.3a19.09,19.09,0,0,0-38.17,0V152"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M101.68,51.91H58.75v-.55A19.61,19.61,0,0,1,78.36,31.75h3.71a19.61,19.61,0,0,1,19.61,19.61v.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M77.83,8V18.08a37.39,37.39,0,0,0,19.08,0V8A37.39,37.39,0,0,1,77.83,8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M73.06,135.3H68.29a11.94,11.94,0,0,1,11.92-11.92v4.77a7.16,7.16,0,0,0-7.15,7.15Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKaBehoerde);
export default __webpack_public_path__ + "static/media/ka_behoerde.8d9f9d66ca94135e3f240acf05cc0f60.svg";
export { ForwardRef as ReactComponent };